import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Form, Container, Button, Alert, Tabs, Tab, Modal, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import api from '../../api';
import firebase from "firebase";
// import styledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth';
import { ModalContext } from '../../contexts/modal';
import ButtonLoader from '../../components/ButtonLoader';
import users from '../../constants/users';

// if (!firebase.apps.length) {
//     firebase.initializeApp({
//         apiKey: "AIzaSyDrpG7YDIJudmqQkE7t0XaYcSQgc8TPvwk",
//         authDomain: "skf-project.firebaseapp.com"
//     });
// } else {
//     firebase.app(); // if already initialized, use that one
// }


// firebase.initializeApp({
//     apiKey: "AIzaSyDrpG7YDIJudmqQkE7t0XaYcSQgc8TPvwk",
//     authDomain: "skf-project.firebaseapp.com"
// })

const Index = () => {
    const { isLogin, loginSuccess, settingProfile, setIsProfileImg, setProfile } = useContext(AuthContext);
    const { phoneModal, setPhoneModal } = useContext(ModalContext);
    const [signIn, setsignIn] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState(false);
    const [alert2, setAlert2] = useState(false);
    const [showPasword, setShowPassword] = useState(false);
    const [resetPasswordModal, setResetPasswordModal] = useState(false);
    const [resetPasswordSuccessAlert, setResetPasswordSuccessAlert] = useState(false);
    const [resetPasswordDangerAlert, setResetPasswordDangerAlert] = useState(false);
    const [tabKey, setTabKey] = useState('resetPasswordEmail');

    const history = useHistory();
    const handleResetPasswordModalClose = () => {
        setResetPasswordModal(false);
        setTabKey('resetPasswordEmail')
    }

    const validSchema = Yup.object().shape({
        email: Yup.string().email().required("required"),
        password: Yup.string().required("required"),
    });

    const resetPasswordvalidSchema = Yup.object().shape({
        email: Yup.string().email().required("required"),
    });
    let res;

    const onSubmit = async (values) => {
        try {
            res = await api.post("/auth/signin", {
                ...values
            });
            console.log('role', res.data.data.user.role)
            if (res.data.data.user.role == 'seller') {
                // history.push("http://localhost:3001/auth/signin")
                // history.push(`${process.env.REACT_APP_VENDOR_PANEL_URL}`)
                window.open(`${process.env.REACT_APP_VENDOR_PANEL_URL}auth/signin?token=${res.data.token}`, '_blank');
            }
            else {
                loginSuccess(res.data.token);
                history.push("/profile")
                //     href = {`${process.env.REACT_APP_VENDOR_PANEL_URL}/auth/signin`
                // }
                if (res.data.data.user.profileImage) {
                    setIsProfileImg(true);
                    setProfile({ profileImage: res.data.data.user.profileImage })
                    loginSuccess(res.data.token);
                }
                console.log(res);
            }
        }
        catch (err) {
            setAlert2(true);
            console.log(err)
        }
    }

    const uiConfig = {
        signInFlow: "popup",
        signInOptions: [
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.FacebookAuthProvider.PROVIDER_ID
        ],
        callbacks: {
            signInSuccess: async (currentUser, credential, redirectUrl) => {
                try {
                    console.log("current user", currentUser)
                    // const userId = currentUser.uid;
                    const res = await api.post('/auth/social/', {
                        firstName: currentUser.displayName,
                        email: currentUser.email,
                        userId: currentUser.uid,
                        profileImage: currentUser.photoURL,
                        userType: users.BUYER_INDIVIDUAL.key
                    });

                    if (res.data.data.user.profileImage) {
                        loginSuccess(res.data.token);
                        setIsProfileImg(true);
                        setProfile({ profileImage: res.data.data.user.profileImage });

                        if (!res.data.data.user.cellNumber) {
                            setPhoneModal(true);
                        }
                    } else {
                        loginSuccess(res.data.token, currentUser.Aa);
                    }

                    // settingProfile(res.data.data.user)
                    redirectUrl = history.push('/profile');
                    return false;
                } catch (err) {
                    console.log('err: ', { ...err })
                    if (err.response.status === 409) {
                        setAlert(true)
                    }
                    redirectUrl = history.push('/signin');
                    return false;
                }
            },
        }
    }

    // firebase.auth().onAuthStateChanged((user) => {
    //     console.log('user: ', user);

    //     if (user) {
    //         console.log("user", user.displayName, user.uid, user.email)
    //         console.log("request going")
    //         api.post('/auth/social', {
    //             firstName: user.displayName,
    //             email: user.email,
    //             userId: user.uid
    //         }).then((res) => {
    //             console.log(res)
    //         }).catch((err) => console.log(err))
    //     }
    // });
    const handleShowPassword = () => {
        showPasword ? setShowPassword(false) : setShowPassword(true)
    }
    const handleResetPasswordEmail = async (values, clearForm) => {
        setIsLoading(true);
        console.log("values", values);
        try {
            const res = await api.post("/users/user/resetPassword", {
                ...values
            });
            console.log(res);
            setResetPasswordDangerAlert(false)
            setResetPasswordSuccessAlert(true)
            clearForm({ values: "" })
            setIsLoading(false);
            setTabKey('resetpasswordMessage')
            // handleResetPasswordModalClose();
        }
        catch (err) {
            console.log(err)
            setResetPasswordSuccessAlert(false)
            setResetPasswordDangerAlert(true)
            setIsLoading(false);
        }
    }
    return (
        <section className="section-signin">
            <Container >
                <div style={{
                    display: "flex", justifyContent: "space-between"
                }}>
                    < h2 className="mb-3" > Welcome to Subka Faida! Please Login</h2>
                    {/* <p className="mb-3">New member?  <Link to="/signup">Register </Link>here</p> */}

                </div>
                {
                    alert ?
                        <Alert variant="danger" className="rounded text-center">User already exist with same email</Alert>
                        : ""
                }
                {
                    alert2 ?
                        <Alert variant="danger" className="rounded text-center">Incorrect email or password</Alert>
                        : ""
                }
                <Row>
                    <Col md={6} sm={12}>
                        <Formik
                            onSubmit={(values, formProps) => trackPromise(onSubmit(values, formProps), 'login')}
                            validationSchema={validSchema}
                            enableReinitialize
                            initialValues={{
                                email: '',
                                password: '',
                            }}
                        >
                            {(formik) => (
                                <Form onSubmit={formik.handleSubmit} id="login">
                                    <Form.Row>
                                        <Form.Group controlId="email" as={Col} hasValidation>
                                            <Form.Label className="form__label">Email</Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                type="text"
                                                name="email"
                                                placeholder="Please Enter Your Phone Number or Email"
                                                value={formik.values.email}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.email && !formik.errors.email}
                                                isInvalid={formik.touched.email && formik.errors.email}
                                            />

                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.email}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        {/* <Form.Group as={Col}>
                                            <Button className="section-signin__loginbutton button" type="submit">LOGIN</Button>
                                            <br />
                                            <span className="section-signin__loginLabel">Or, login with</span>
                                        </Form.Group> */}
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group controlId="password" as={Col} className="isValidHide" hasValidation>
                                            <Form.Label className="form__label">Password</Form.Label>
                                            <div style={{ position: "relative", display: "flex" }}>
                                                <Form.Control
                                                    className="p-3 rounded-0 "
                                                    // style={{backG}}
                                                    type={showPasword ? "text" : "password"}
                                                    name="password"
                                                    placeholder="Please Enter Your Password"
                                                    value={formik.values.password}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    isValid={formik.touched.password && !formik.errors.password}
                                                    isInvalid={formik.touched.password && formik.errors.password}
                                                />
                                                {

                                                    showPasword ?
                                                        <i class="fas fa-eye-slash" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                            console.log("password show")
                                                            handleShowPassword()
                                                        }}></i>
                                                        :
                                                        <i class="far fa-eye" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                            console.log("password show")
                                                            handleShowPassword()
                                                        }} ></i>
                                                }
                                            </div>
                                            <Form.Control.Feedback style={{ display: "block" }} type="invalid">
                                                {formik.errors.password}
                                            </Form.Control.Feedback>

                                            <Link className="section-signin__forgotLabel" onClick={() => {
                                                setResetPasswordModal(true)
                                            }}>Forgot Password?</Link>
                                        </Form.Group>
                                        {/* <Form.Group as={Col}>
                                            <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
                                            <Button onClick={() => firebase.auth().signOut()}>Sign out</Button>
                                        </Form.Group> */}
                                    </Form.Row>
                                </Form>
                            )}
                        </Formik>
                    </Col>

                    <Col md={6} sm={12}>
                        {
                            <Button className="button section-signin__login-btn button btn-block rounded-0" type="submit" form="login">
                                <ButtonLoader trackerArea="login">
                                    Login
                                </ButtonLoader>
                            </Button>
                        }
                        <p className="mt-1 mb-0">Or, login with</p>
                        <StyledFirebaseAuth className="firebase-ui-cus" uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
                    </Col>
                </Row>
                <Modal
                    show={resetPasswordModal}
                    onHide={handleResetPasswordModalClose}
                    centered
                    size="lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Reset Password
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* {
                            resetPasswordSuccessAlert ?
                                <Alert variant="success" className="rounded">A password reset link has been sent to your
                                    email address</Alert>
                                : ""
                        }
                        {
                            resetPasswordDangerAlert ?
                                <Alert variant="danger" className="rounded">No user registered with with email</Alert>
                                : ""
                        } */}
                        <Tabs
                            defaultActiveKey={tabKey}
                            transition={false}
                            id="noanim-tab-example"
                            className="my-tabs"
                        >
                            <Tab eventKey="resetPasswordEmail" title="" active={tabKey === "resetPasswordEmail" ? true : false} >
                                <Formik
                                    onSubmit={(values, { resetForm }) => {
                                        handleResetPasswordEmail(values, resetForm)
                                        // resetForm({ values: "" })
                                    }}
                                    validationSchema={resetPasswordvalidSchema}
                                    enableReinitialize
                                    initialValues={{
                                        email: ''
                                    }}
                                >
                                    {(formik) => (
                                        <Form onSubmit={formik.handleSubmit} id="createBusinessCategoryForm">
                                            <Form.Group controlId="email" as={Col} hasValidation>
                                                <Form.Label className="form__label">Email</Form.Label>
                                                <Form.Control
                                                    className="p-3 rounded-0"
                                                    type="text"
                                                    name="email"
                                                    placeholder="Please Enter Your Email"
                                                    value={formik.values.email}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    isValid={formik.touched.email && !formik.errors.email}
                                                    isInvalid={formik.touched.email && formik.errors.email}
                                                />

                                                <Form.Control.Feedback type="invalid">
                                                    {formik.errors.email}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Form>
                                    )}
                                </Formik>
                            </Tab>
                            <Tab eventKey="resetpasswordMessage" title="" active={tabKey === "resetpasswordMessage" ? true : false}>
                                <div >
                                    <span style={{ fontSize: '20px', }}>
                                        <span>
                                            Don’t worry,<br />
                                            A <b>password reset link has been sent to your registered <br />
                                                email</b>  address valid for 24 hours only. <br /> <br />
                                            If you don’t find the email in primary folder, kindly check other folders <br />
                                            before you register a complaint.
                                        </span>
                                    </span>
                                </div>
                            </Tab>
                        </Tabs>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleResetPasswordModalClose}>
                            Close
                        </Button>
                        {
                            tabKey !== 'resetpasswordMessage' ?
                                <Button className="button" type="submit" form="createBusinessCategoryForm">
                                    {isLoading ? (
                                        <Spinner animation="border" size="sm" />
                                    ) : ('')}
                                    <span className={`${isLoading ? 'ml-2' : ''}`}>Submit</span>
                                </Button>
                                : ""
                        }

                    </Modal.Footer>
                </Modal>
            </Container>
        </section >
    )
}

export default Index;
